import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1),
};

export const count: SxStyle = {
  display: 'flex',
  background: (p) => p.palette.primary[50],
  borderRadius: (p) => p.spacing(0.5),
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[200],
  color: (p) => p.palette.primary[500],
  fontSize: (p) => p.typography.pxToRem(10),
  padding: (p) => p.spacing(0.5),
};
